// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.message-content[data-v-1758328e] {\n  width: 95%;\n  margin: 30px auto;\n}\n.message-content .message[data-v-1758328e] {\n  background: transparent;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
